import React, { useState } from "react";
import TnvedTreeNode from "../tnved-tree-node";

import './tnved-tree.scss';

const getLoadedNodes = (nodes: TnvedHierarchyDictionaryItem[]): TnvedHierarchyDictionaryItem[] => {
  return nodes.flatMap((node) => [ node, ...getLoadedNodes(node.children || []) ]);
};

const TnvedTree: React.FC<TnvedTree> = ({ data, onToggle, handleApplyCode, code }) => {

  const loadedNodes = getLoadedNodes(data);
  const normalizedCode = code?.replace(/\s+/g, '');
  const selectedNode = loadedNodes.find((node) => node.code === normalizedCode);

  const [ expandedIds, setExpandedIds ] = useState<Set<number>>(() => {
    return new Set(loadedNodes.filter((node) => node.children?.length).map((node) => node.id));
  });
  const [ activeId, setActiveId ] = useState<number | null>(selectedNode?.id || null);
  const highlightedId = selectedNode?.id ?? activeId;

  const handleToggle = (id: number, code?: string) => {
    const isExpanded = expandedIds.has(id);

    setExpandedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }

      return next;
    });
    setActiveId(id);

    if (!isExpanded) {
      onToggle(id, code);
    }
  };

  return (
    <div className='tnved-tree'>
      {data.map((node, index) => (
        <TnvedTreeNode
          key={node.id}
          node={node}
          depth={0}
          expandedIds={expandedIds}
          onToggle={handleToggle}
          activeId={highlightedId}
          index={index}
          siblingsCount={data.length}
          handleApplyCode={handleApplyCode}
        />
      ))}
    </div>
  );
};

export default TnvedTree;
